import { defineMessages } from 'react-intl';

const messages = defineMessages({
  Unknown: {
    id: 'Errors.Unknown',
    defaultMessage: 'An unknown error occurred.',
  },
  'Survey is disabled': {
    id: 'Errors.Survey is disabled',
    defaultMessage: 'This survey is disabled, please enable it to be able to send it.',
  },
  'Limits reached': {
    id: 'Errors.Limits reached',
    defaultMessage: 'You have reached your sending limit. Upgrade your plan to send more surveys.',
  },
  'Number of monthly messages in your plan exceeded': {
    id: 'Errors.PlanQuotaExceeded',
    defaultMessage: 'You have exceeded the number of surveys in your plan.',
  },
  'Number of messages in trial period exceeded': {
    id: 'Errors.TrialQuotaExceeded',
    defaultMessage: 'You have exceeded the number of surveys for the trial period.',
  },
  'Trial expired': {
    id: 'Errors.Trial expired',
    defaultMessage: 'Your trial has expired. Choose a plan to continue sending surveys.',
  },
});

const getErrorMessageKey = ({ message }) => {
  return messages[message] || messages.Unknown;
};

export default getErrorMessageKey;
